<script lang="ts" setup>
const { required = false } = defineProps<{
  required?: boolean;
}>();
const classObject = computed(() => ({
  "is-required": required,
}));
</script>

<template>
  <label class="form-label" :class="classObject">
    <slot />
  </label>
</template>

<style lang="scss" scoped>
.form-label {
  display: block;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: left;

  &.is-required:after {
    content: " *";
    color: var(--main-error-color);
  }
}
</style>
